import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { IconClose, IconHotelSecond, IconPlane } from '@travel-frontend/icons';
import { useCallback } from 'react';
import { useAirportsLabel } from '../../../../../../../components/SearchForm/components/AirportsField/hooks/useAirportsLabel.js';
import { IconWrapper } from '../../../../../../../components/SearchForm/components/DestinationWidget/components/BlockLastSearches/components/IconWrapper.js';
import { LastSearchesSubline } from '../../../../../../../components/SearchForm/components/DestinationWidget/components/BlockLastSearches/components/LastSearchesSubline.js';
import { SearchWrapper } from '../../../../../../../components/SearchForm/components/DestinationWidget/components/BlockLastSearches/components/SearchWrapper.js';
import { SublineWrapper } from '../../../../../../../components/SearchForm/components/DestinationWidget/components/BlockLastSearches/components/SublineWrapper.js';
import { LabelMediumSemiBold, LabelSmall, Stack } from '../../../../../../../primitives/index.js';
import { SPACING_NONE, SPACING_SMALL } from '../../../../../../../utils/spacingLegacy.js';
export const SearchItem = ({
  data,
  onClick,
  config,
  onRemove
}) => {
  const handleClick = useCallback(() => onClick(data), [data, onClick]);
  const label = useAirportsLabel({
    airports: data.values.airports,
    config: config.airports,
    forcedNeutralLabel: config.forcedNeutralLabel,
    primaryCountry: config.countryCode
  });
  const travelTypeIcon = data.travelType === 'packageTour' ? _jsx(IconPlane, {}) : _jsx(IconHotelSecond, {});
  return _jsxs(SearchWrapper, {
    spacing: SPACING_NONE,
    children: [_jsxs(Stack, {
      spacing: SPACING_NONE,
      onClick: handleClick,
      children: [_jsxs(Stack, {
        direction: "row",
        spacing: SPACING_SMALL,
        alignItems: "center",
        children: [travelTypeIcon, _jsx(LabelMediumSemiBold, {
          children: data.values.destination?.keyword
        })]
      }), _jsxs(SublineWrapper, {
        spacing: SPACING_NONE,
        children: [data.travelType === 'packageTour' ? _jsx(LabelSmall, {
          children: label
        }) : null, _jsx(LastSearchesSubline, {
          data: data
        })]
      })]
    }), _jsx(IconWrapper, {
      children: _jsx(IconClose, {
        onClick: onRemove
      })
    })]
  });
};